<template>
  <div class="crawl-options">
    <a-row :gutter="24">
      <a-col :span="colSpan">
        <a-form-item>
          <span slot="label">
            Crawl Depth&nbsp;
            <a-tooltip :title="crawlDepthTooltip">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
          <a-input-number
            :value="depth"
            :min="1"
            :max="20"
            size="large"
            style="width: 100%"
            @change="$emit('update:depth', $event)"
          />
        </a-form-item>
      </a-col>
      <a-col :span="colSpan">
        <a-form-item>
          <span slot="label">
            Page Limit&nbsp;
            <a-tooltip title="Maximum number of pages to crawl per domain">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
          <a-input-number
            :value="limit"
            :min="1"
            :max="10000"
            size="large"
            style="width: 100%"
            @change="$emit('update:limit', $event)"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="colSpan">
        <a-form-item label="Depth Mode">
          <a-radio-group
            class="mode-radio-group mode-radio-group--depth"
            :value="depthMode"
            size="large"
            @change="$emit('update:depthMode', $event.target.value)"
          >
            <a-radio-button v-for="mode in DepthModes" :key="mode.value" :value="mode.value">
              {{ mode.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="colSpan">
        <a-form-item>
          <span slot="label">
            URL Report Mode&nbsp;
            <a-tooltip title="URL Report Mode only affects the email report. The portal will still show all crawled URLs.">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
          <a-radio-group
            class="mode-radio-group mode-radio-group--report"
            :value="urlReportMode"
            size="large"
            @change="$emit('update:urlReportMode', $event.target.value)"
          >
            <a-radio-button v-for="mode in UrlReportModes" :key="mode.value" :value="mode.value">
              {{ mode.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import { DEFAULT_DEPTH, DEFAULT_PAGE_LIMIT } from '../helpers/crawl-validation';
  import {
    DEPTH_MODE,
    DEFAULT_DEPTH_MODE,
    DEFAULT_URL_REPORT_MODE,
    DepthModes,
    UrlReportModes,
  } from '../consts/CrawlStatus.consts';

  export default {
    name: 'CrawlOptions',
    props: {
      depth: {
        type: Number,
        default: DEFAULT_DEPTH,
      },
      limit: {
        type: Number,
        default: DEFAULT_PAGE_LIMIT,
      },
      depthMode: {
        type: String,
        default: DEFAULT_DEPTH_MODE,
      },
      urlReportMode: {
        type: String,
        default: DEFAULT_URL_REPORT_MODE,
      },
      colSpan: {
        type: Number,
        default: 8,
      },
    },
    computed: {
      DepthModes: () => DepthModes,
      UrlReportModes: () => UrlReportModes,
      crawlDepthTooltip() {
        if (this.depthMode === DEPTH_MODE.CLICK) {
          return 'How many discovered-link levels to follow from the seed URL';
        }
        return 'How many URL path-segment levels to crawl';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mode-radio-group {
    display: inline-flex;

    ::v-deep .ant-radio-button-wrapper {
      padding-right: 10px;
      padding-left: 10px;
      text-align: center;
    }

    &--depth {
      ::v-deep .ant-radio-button-wrapper {
        width: 116px;
      }
    }

    &--report {
      ::v-deep .ant-radio-button-wrapper {
        width: 140px;
      }
    }
  }
</style>
